import styled from 'styled-components';
import {
  Popper,
  TextField,
  IconButton,
} from '@mui/material';

import colors from '../../../../../../../styles/colors';

const StyledPopper = styled(Popper)`
  z-index: 1300;
  background: ${colors.base.alpha};
  border: 1px solid ${colors.shades.gamma3};
  border-radius: 8px;
  box-shadow: 0 4px 16px ${colors.addAlpha(colors.base.beta, 0.12)};
  width: 320px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const SearchWrapper = styled.div`
  padding: 8px;
`;

const SearchInput = styled(TextField)`
  width: 100%;
  & .MuiInputBase-root {
    border-radius: 6px;
    background: ${colors.base.gamma};
  }
`;

const IconGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  padding: 4px 8px 8px;
  overflow-y: auto;
  max-height: 320px;
`;

const IconCell = styled(IconButton)`
  width: 40px;
  height: 40px;
  border-radius: 6px !important;
  color: ${({ $selected, $disabled }) => {
    if ($selected) return colors.base.secondary;
    if ($disabled) return colors.shades.gamma6;
    return colors.shades.gamma10;
  }} !important;
  background: ${({ $selected, $disabled }) => {
    if ($selected) return colors.shades.secondary5;
    if ($disabled) return colors.base.gamma;
    return 'transparent';
  }} !important;
  border: 1px solid ${({ $selected, $disabled }) => {
    if ($selected) return colors.base.secondary;
    if ($disabled) return colors.shades.gamma4;
    return 'transparent';
  }} !important;
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};

  &:hover {
    background: ${({ $selected, $disabled }) => {
    if ($selected) return colors.shades.secondary5;
    if ($disabled) return colors.base.gamma;
    return colors.base.gamma;
  }} !important;
  }
`;

export {
  StyledPopper,
  SearchWrapper,
  SearchInput,
  IconGrid,
  IconCell,
};
